import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import i18n from './i18n'
import jQuery from 'jquery';
import {VueReCaptcha} from "vue-recaptcha-v3";
import { installGlobalErrorLogging } from '@/helpers/clientLog';

window.$ = window.jQuery = jQuery;

Vue.config.productionTip = false;
installGlobalErrorLogging(Vue);

Vue.use(VueReCaptcha, {
	siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
});

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');